module.exports = __webpack_public_path__ + "static/media/snowyLake.dc102e98.jpg";